import { Icon, Button, Container, Segment, SegmentInline } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { useState, useEffect } from 'react';
import ContentContainer from './ContentContainer.js';
import { waitSomeTime } from '../utils/helpers.js';
import '../stylesheets/App.css';
import '../stylesheets/ContentHotspot.less';

const ContentHotspot = ({ hotspotComponent, name, groupIndex, index, inViewpoint, content, autoOpenHotspot }) => {
    
    const [isOpen, setIsOpen] = useState(false)
    const [screenCoords, setScreenCoords] = useState({
        x: hotspotComponent?.data.screenCoordX, 
        y: hotspotComponent?.data.screenCoordY,
        objectOffScreen: false
    })
    
    const createScreenCoordUpdateRef = () => {
        if (groupIndex == null || index == null)
            return;
        window.ViewHotspotRefs[groupIndex][index] = () => {
            if (screenCoords.x === hotspotComponent?.data.screenCoordX
            && screenCoords.y === hotspotComponent?.data.screenCoordY) {
                return;
            }
            setScreenCoords({ 
                x: hotspotComponent?.data.screenCoordX || 0,
                y: hotspotComponent?.data.screenCoordY || 0,
                objectOffScreen: hotspotComponent?.data.objectOffScreen
            });
        }
    }
    createScreenCoordUpdateRef();

    useEffect( () => {
        createScreenCoordUpdateRef();

        setScreenCoords({ 
            x: hotspotComponent?.data.screenCoordX || 0,
            y: hotspotComponent?.data.screenCoordY || 0,
            objectOffScreen: hotspotComponent?.data.objectOffScreen
        });

        // Cleanup setScreenCoords reference when component unmounted
        return () => {
            window.ViewHotspotRefs[groupIndex][index] = null;
        }
    }, [hotspotComponent]);

    const handleOpenUrl = (url) => window.open(url);

    const openPopup = () => {
        const canvas = document.getElementsByClassName("a-canvas");
        if (canvas != null) {
            canvas[0].addEventListener('click', closePopup, true);
        }
        setIsOpen(true);
    }

    // Hack to open hidden hotspot from menu bar
    // useEffect(() => {
    //     if (window.hackOpenHiddenHotspot !== undefined && window.hackOpenHiddenHotspot !== null) return;
    //     window.hackOpenHiddenHotspot = (groupIndex === 0 && index === 8) ? openPopup.bind(this) : null;
    // }, []);

    const closePopup = (event) => {
        event.preventDefault();
        setIsOpen(false);
        const canvas = document.getElementsByClassName("a-canvas");
        if (canvas != null) {
            canvas[0].removeEventListener('click', closePopup, true);
        }
    }

    // Auto-opens a content hotspot when parent updates the prop
    // - Note! Only works if there is one Content Hotspot per viewpoint
    useEffect(() => {
        if (groupIndex == "0" || groupIndex == 0) return; // if this is lobby, don't do anything
        waitSomeTime(2000).then(() => openPopup());
      }, [autoOpenHotspot]);
    
    const generateViewpointStyle = () => {
        return { 
            left: (screenCoords.objectOffScreen) ? -100 : screenCoords.x, 
            right: 'auto', 
            top: (screenCoords.objectOffScreen) ? -100 : screenCoords.y,
            bottom: 'auto',
            zIndex: 1001,
            position: 'fixed',
            display: (groupIndex === 0 && index === 8) ? 'none' : 'block' // hack to not show one hotspot in lobby
        }
    }

    return (
        <>
            <div style={generateViewpointStyle()}>
                <div className="catch-pointer-events">
                    <Button 
                        icon labelPosition="right" 
                        className="catch-pointer-events hotspot-button" 
                        color={(groupIndex !== 0) ? "blue" : "green"} size='large' 
                        onClick={(content.includes("https://")) ? () => handleOpenUrl(content) : openPopup}
                    >
                        {name}
                        <Icon name={(content.includes("video")) ? "play circle": "info circle"} size="large"></Icon>
                    </Button>
                </div>
            </div>
            {
                (isOpen) ?
                <Container id={(content.includes("video")) ? "overlay-content-ui-video" : "overlay-content-ui"} key="overlay-content-ui" className="overlay-content scrolling-container catch-pointer-events">
                    <Icon.Group className="close-spot-content catch-pointer-events" onClick={closePopup}>
                        <Icon name="circle" size="large"/>
                        <Icon name="times circle" color="blue" size="big" onClick={closePopup}/>
                    </Icon.Group>
                    <ContentContainer inViewpoint={inViewpoint} content={content} key={groupIndex + '_cc_' + index} /*className="catch-pointer-events"*//>
                </Container>
                : null
            }
            {
                (isOpen) ?
                    <div className='content-hotspot-overlay'> </div>
                : null
            }
        </>
    )
};

ContentHotspot.propTypes = {
    hotspotComponent: PropTypes.object,
    name: PropTypes.string,
    groupIndex: PropTypes.number,
    index: PropTypes.number,
    inViewpoint: PropTypes.string,
    content: PropTypes.string
}

export default ContentHotspot;